(function () {
  'use strict';

  const root = document.querySelector('[data-ladwig-root]');
  const dataNode = root && root.querySelector('[data-ladwig-products]');
  if (!root || !dataNode) return;

  let products;
  try {
    products = JSON.parse(dataNode.textContent);
  } catch (_) {
    return;
  }

  const isFramed = product => String(product.title || '').toLowerCase().includes('(framed)');
  const hasTrackedStock = variant => Boolean(variant.inventory_management) && Number(variant.inventory_quantity) > 0;
  const eligibleReady = (product, variant) => isFramed(product) && variant.available && hasTrackedStock(variant);
  const eligibleOrder = (product, variant) => variant.available && (!isFramed(product) || !hasTrackedStock(variant));
  const dimensions = product => {
    const html = String(product.description_html || '');
    const marker = /dimensions?\s*:/i.exec(html);
    if (!marker) return '';
    let remainder = html.slice(marker.index + marker[0].length).trim();
    while (remainder.startsWith('<')) {
      const end = remainder.indexOf('>');
      if (end < 0) break;
      remainder = remainder.slice(end + 1).trim();
    }
    const value = remainder.split(/[<\r\n]/, 1)[0].replace(/&nbsp;/gi, ' ').trim();
    return value;
  };
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency: root.dataset.currency || 'USD'
  }).format(Number(cents || 0) / 100);
  const element = (tag, className, value) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (value !== undefined) node.textContent = value;
    return node;
  };

  function productCard(product, variants, sectionName) {
    const card = element('article', `ladwig-card ladwig-card-${sectionName}`);
    const imageLink = element('a', 'ladwig-card-image-link');
    const image = element('img', 'ladwig-card-image');
    image.loading = 'lazy';
    image.width = 900;
    image.height = 900;
    imageLink.append(image);
    card.append(imageLink);

    const body = element('div', 'ladwig-card-body');
    const heading = element('h3');
    const title = element('a', 'ladwig-card-title', product.title);
    heading.append(title);
    const price = element('p', 'ladwig-card-price');
    const sizeNote = element('p', 'ladwig-size');
    const selectorId = `ladwig-${sectionName}-${product.id}`;
    const label = element('label', '', 'Size and format');
    label.htmlFor = selectorId;
    const select = element('select', 'ladwig-variant-select');
    select.id = selectorId;
    variants.forEach(variant => {
      const option = element('option', '', variant.title);
      option.value = String(variant.id);
      select.append(option);
    });
    const timing = element('p', 'ladwig-timing');
    timing.setAttribute('aria-live', 'polite');
    body.append(heading, price);
    body.append(sizeNote);
    if (variants.length > 1) body.append(label, select);
    body.append(timing);
    card.append(body);

    const update = () => {
      const variant = variants.find(item => String(item.id) === select.value) || variants[0];
      const href = `${product.url}?variant=${encodeURIComponent(variant.id)}`;
      imageLink.href = href;
      title.href = href;
      image.src = variant.image || product.image || '';
      image.alt = `${product.title}${['Default Title', 'Default'].includes(variant.title) ? '' : ` — ${variant.title}`}`;
      price.textContent = money(variant.price);
      const size = ['Default Title', 'Default'].includes(variant.title) ? dimensions(product) : variant.title;
      sizeNote.textContent = size ? `Image size: ${size}` : '';
      timing.textContent = sectionName === 'ready'
        ? 'Framed at Xanadu Gallery and ready to ship.'
        : (isFramed(product) ? 'Framed to order. Ships in 4–7 weeks.' : 'Printed to order. Ships in 3–4 weeks.');
    };
    select.addEventListener('change', update);
    select.value = String(variants[0].id);
    update();
    return card;
  }

  function renderCollection() {
    const ready = root.querySelector('[data-ladwig-ready]');
    const order = root.querySelector('[data-ladwig-order]');
    if (!ready || !order) return;
    products.forEach(product => {
      const readyVariants = product.variants.filter(variant => eligibleReady(product, variant));
      const orderVariants = product.variants.filter(variant => eligibleOrder(product, variant));
      if (readyVariants.length) ready.append(productCard(product, readyVariants, 'ready'));
      if (orderVariants.length) order.append(productCard(product, orderVariants, 'order'));
    });
    if (!ready.children.length) ready.append(element('p', 'ladwig-empty', 'No framed artwork is ready to ship right now.'));
    if (!order.children.length) order.append(element('p', 'ladwig-empty', 'No artwork is currently available to order.'));
  }

  function renderProductStatus() {
    const product = products.find(item => String(item.id) === String(root.dataset.productId));
    const panel = root.querySelector('[data-ladwig-product-status]');
    if (!product || !panel) return;

    const selectedVariant = () => {
      const optionSelectors = Array.from(document.querySelectorAll('form.product-form .single-option-selector'));
      if (optionSelectors.length) {
        const options = Object.fromEntries(optionSelectors.map(selector => [selector.dataset.index, selector.value]));
        const matched = product.variants.find(variant => Object.entries(options).every(([key, value]) => String(variant[key] || '') === String(value)));
        if (matched) return matched;
      }
      const selectors = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
      const checked = Array.from(selectors).find(selector => selector.type === 'radio' && selector.checked);
      const selector = checked || Array.from(selectors).find(candidate => candidate.type !== 'radio');
      const selectedId = selector && selector.value;
      const urlVariant = new URLSearchParams(window.location.search).get('variant');
      return product.variants.find(variant => String(variant.id) === String(selectedId || urlVariant))
        || product.variants.find(variant => String(variant.id) === String(urlVariant))
        || product.variants.find(variant => variant.available)
        || product.variants[0];
    };
    const update = () => {
      const variant = selectedVariant();
      if (!variant) return;
      panel.className = `ladwig-product-message ${eligibleReady(product, variant) ? 'is-ready' : eligibleOrder(product, variant) ? 'is-order' : 'is-unavailable'}`;
      const timing = eligibleReady(product, variant)
        ? 'Framed at Xanadu Gallery and ready to ship.'
        : eligibleOrder(product, variant)
          ? (isFramed(product) ? 'Framed to order. Ships in 4–7 weeks.' : 'Printed to order. Ships in 3–4 weeks.')
          : 'This variant is currently unavailable.';
      const size = ['Default Title', 'Default'].includes(variant.title) ? dimensions(product) : variant.title;
      panel.textContent = size ? `Image size: ${size} — ${timing}` : timing;
    };

    document.addEventListener('change', event => {
      if (event.target && event.target.matches('form.product-form .single-option-selector, form[action*="/cart/add"] [name="id"]')) {
        window.requestAnimationFrame(update);
        window.setTimeout(update, 40);
      }
    });
    document.addEventListener('variant:change', update);
    document.addEventListener('shopify:section:load', update);
    window.addEventListener('popstate', update);
    update();
  }

  if (root.dataset.mode === 'product') renderProductStatus();
  else renderCollection();
})();
